import React, { useEffect, useRef } from "react";
import { stats, storyImage } from "../mock";
import { animateCount } from "../hooks/useReveal";

export default function Story() {
  const statsRef = useRef(null);

  useEffect(() => {
    const nodes = statsRef.current?.querySelectorAll("[data-count]") || [];
    const cio = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            animateCount(e.target);
            cio.unobserve(e.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    nodes.forEach((n) => cio.observe(n));
    return () => cio.disconnect();
    // Mount-only: builds the counter observer once. animateCount is a stable import.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section id="story">
      <div className="wrap">
        <div className="story-grid">
          <div className="story-copy">
            <span className="eyebrow" data-reveal="fade">Our story</span>
            <h2 className="story-title" data-reveal="fade" data-reveal-delay="1">
              A business student who chose hospitality over a boardroom.
            </h2>
            <p className="lead" data-reveal data-reveal-delay="1">
              “I came here with a suitcase, a business plan, and a stubborn belief that a good cup
              of coffee can hold a whole room together.”
            </p>
            <p data-reveal data-reveal-delay="2">
              Shubh Magajwala left India for London to study business management — a life of
              spreadsheets, supply chains and late-night case studies. On paper, the plan was a
              corporate desk and a tidy career.
            </p>
            <p data-reveal data-reveal-delay="3">
              But every evening he ended up in the city's cafés, watching how a warm welcome turned
              strangers into regulars. He realised the business he actually wanted to be in wasn't
              consulting — it was hospitality. So he began sketching a café that paired the food he
              grew up with and the coffee culture he'd fallen in love with, turning class projects
              into a real, working business plan.
            </p>
            <p data-reveal data-reveal-delay="4">
              Cloud9 is that plan made real — Shubh's dream café, where a business-school vision
              meets an Indian kitchen's soul, and every guest gets a seat and a story.
            </p>
            <div className="story-signature" data-reveal data-reveal-delay="4">
              — Shubh Magajwala, founder
            </div>
          </div>
          <div className="story-panel" data-reveal data-reveal-delay="2" ref={statsRef}>
            <div className="story-photo">
              <img src={storyImage} alt="Inside Cloud9 café" loading="lazy" />
            </div>
            <div className="stat-grid">
              {stats.map((s) => (
                <div className="stat" key={s.label}>
                  <b data-count={s.count} data-format={s.format} data-suffix={s.suffix}>0</b>
                  <span>{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
